/**
 * Публичный ID счётчика. Задаётся при сборке: GATSBY_YANDEX_METRIKA_ID=12345678
 */
exports.yandexMetrikaId = process.env.GATSBY_YANDEX_METRIKA_ID || ``
